import React from "react";
import useAutoGrowTextarea from "../../utils/useAutoGrowTextarea";

// Answer box for open-ended questions. Unlike the short-answer input this is built for
// extended writing: it grows with the answer, Enter makes a new line rather than
// submitting, and it shows the mark allocation so the student knows how much to write.
const ProbabilisticResponseInput = ({
  value,
  onChange,
  isLocked,
  outcome,          // "correct" | "partial" | "incorrect" | null
  maxMarks,
  isGrading,
}) => {
  const inputRef = useAutoGrowTextarea(value);

  const words = (value ?? "").trim() ? (value ?? "").trim().split(/\s+/).length : 0;

  const ring = {
    correct:   "border-emerald-300 focus:border-emerald-400 focus:ring-emerald-100",
    partial:   "border-amber-300   focus:border-amber-400   focus:ring-amber-100",
    incorrect: "border-rose-300    focus:border-rose-400    focus:ring-rose-100",
  }[outcome] ?? "border-slate-200 focus:border-sky-400 focus:ring-sky-100";

  return (
    <div className="w-full space-y-1.5">
      <div className="flex items-baseline justify-between">
        <span className="text-xs font-medium text-slate-500">Your answer</span>
        {maxMarks > 1 && (
          <span className="text-xs text-slate-400">
            {maxMarks} Marks
          </span>
        )}
      </div>

      <textarea
        ref={inputRef}
        value={value ?? ""}
        onChange={(e) => onChange(e.target.value)}
        disabled={isLocked || isGrading}
        rows={3}
        placeholder="Write your answer in full sentences…"
        className={`w-full rounded-xl border px-4 py-3 text-sm leading-relaxed text-slate-800
          bg-white outline-none ring-4 ring-transparent transition-all duration-200
          overflow-hidden resize-none
          disabled:bg-slate-50 disabled:cursor-not-allowed disabled:text-slate-500
          ${ring}`}
      />

      <div className="flex justify-end">
        <span className="text-[11px] tabular-nums text-slate-400">
          {words} {words === 1 ? "word" : "words"}
        </span>
      </div>
    </div>
  );
};

export default ProbabilisticResponseInput;
